import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class KaspiPriceEditValidator {

    product_id = [
        Validators.required
    ];

    price = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        product_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        price: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}